import * as React from "react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
const NameFormGroup = () => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(Field, { name: "name" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "name",
      label: t("name_form_group.label"),
      required: true,
      onChange,
      help: t("name_form_group.help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      value: value != null ? value : ""
    }
  ));
};
export default NameFormGroup;
